export class ServiceConsts {
    static SERVER_URL = "https://account.collabwriting.com";
    static SERVER_TEST_URL = "https://cowrite-test.azurewebsites.net";
    static CDN_PUBLIC_URL = "https://collabwriting.azureedge.net/public/";
    static API_URL = this.SERVER_URL + "/api";
    static LOGIN_URL = this.SERVER_URL + "/auth/token/code/get/";
    static SIGNUP_URL = this.SERVER_URL + "/signup";
    static LOGOUT_URL = this.SERVER_URL + "/logout";
    static AUTH_HEADER = "Authorization";
    static TOPIC_PARAM_NAME = ":tid:";
    static SNIPPET_PARAM_NAME = ":sid:";
    static COMMENT_PARAM_NAME = ":cid:";

    static BUILD_MODE = 'BUILD';

    static HTTP_GET = {
        method: "GET",
        headers: { "Content-Type": "application/json" },
    };

    static DASHBOARD_URL = "https://app.collabwriting.com";
    static DASHBOARD_TEST_URL = "https://beta.collabwriting.com";
    static DASHBOARD_DEV_URL = "http://localhost"; // ignoring ports
    static DASHBOARD_AZURETEST_PR_TO_DEV_URL = "https://jolly-plant-0557bdc10";
    static DASHBOARD_AZURETEST_DEV_TO_MAIN_URL =
        "https://lively-mushroom-01142a00f";
    static HELP_URL = "https://help.collabwriting.com";
    static OFFERS_URL = "https://collabwriting.com#pricing";

    static PUBLIC_PDF_URL = this.SERVER_URL + "/public/";

    static LOAD_URL_LEGACY = "https://collabwriting.com/v0.9/snippet";
    static LOAD_URL_LEGACY_PARAM = "cw-firebase-snippet-id";
    static LOAD_URL = "https://cowrite.me/v/";
    static SHARED_DOMAIN = "cowrite.me";
    static SHARED_URL = "https://cowrite.me/";

    static CHROME_EXTENSION_ID = "jjefmmjicedljonbpdoeceklnhobmolo";
    static EDGE_EXTENSION_ID = "oaaidbemenheminahjaojcafppklekjd";

    static CLOUD_FLARE_WORKER =
        "https://bye-cors-beta.collabwriting.workers.dev/?url=";

    static FASTSPRING_ACCOUNT_URL =
        "https://collabwriting.test.onfastspring.com/account";

    static SNIPPET_PARAM_NAME = ":sid:";
    static TOPIC_PARAM_NAME = ":tid:";

    static ANALYTICS_URL = "https://cowrite-analytics.azurewebsites.net";

    static KINDLE_URL = "https://read.amazon.com";
    static KINDLE_HIGHLIGHTS_PATH = "/notebook";
    static KINDLE_APP_URL = "kindle://book/?action=open&asin=";
    static KINDLE_APP_LOCATION_URL = "&location=";
    static KINDLE_DOWNLOAD_URL = "https://www.amazon.com/kindle-dbs/kcpApp";

    static VARIANT_TEAM_ANNUAL_ID =
        "82dd7263-ad3a-4531-9c42-8ba3935680ca?enabled=329190";
    static VARIANT_TEAM_MONTHLY_ID =
        "f1a6d1dd-8650-4a51-aa9d-d46581fcf2cd?enabled=329189";

    static VARIANT_PRO_ANNUAL_ID =
        "40d55448-3905-494f-a617-efb9cd59f281?enabled=122588";
    static VARIANT_PRO_MONTHLY_ID =
        "80b9b953-ae8a-4e72-b831-8d4819a557a2?enabled=122587";

    // Paddle Constants
    static PADDLE_VENDOR_ID = this.isDevMode() ? 30817 : 223829;
    static PADDLE_CLIENT_TOKEN = this.isDevMode() ? "test_2f228e5f3fc4cbb841c18a76cd8" : "live_df6d2d11b491fdd6b2d4e170ea7";
    static PADDLE_PRODUCT_IDS = {
        PRO_MONTHLY: this.isDevMode() ? "pri_01jtak1csaqj1p28e19stwp75m" : "pri_01jt87d6mb1ygd59msc594emgv",
        PRO_ANNUAL: this.isDevMode() ? "pri_01jtak1t8a7684zbqzgbmxcew8" : "pri_01jt87e3vhqthhvyy3zdrce21s",
        TEAM_MONTHLY: this.isDevMode() ? "pri_01jtak2qjw7j80rc8bfderk3yb" : "pri_01jt87gad8bfbfmh272jyg0w9b",
        TEAM_ANNUAL: this.isDevMode() ? "pri_01jtak2zvsaz8zjzm8d4cmy2bt" : "pri_01jt87gy8gh17tfy310dawn0h8"
    };

    static SLACK_DISTRIBUTION_APP_URL =
        "https://slack.com/oauth/v2/authorize?client_id=3806146130880.7593276272887&scope=channels:read,chat:write,im:read,im:write,team:read,users:read,users:read.email,users.profile:read&user_scope=channels:read,channels:write,chat:write,groups:write,im:write,users:read,users:read.email,users.profile:read&state=";

    static isDevMode() {
        return this.BUILD_MODE === "DEV";
    }

    static isDashboardUrl = (url) => {
        if (!url.startsWith("http://") && !url.startsWith("https://")) {
            url = "https://" + url; 
        }
        try {
            let urlObject = new URL(url);
            url = urlObject.protocol + "//" + urlObject.hostname;
    
            return (
                [
                    this.DASHBOARD_URL,
                    this.DASHBOARD_TEST_URL,
                    this.DASHBOARD_DEV_URL,
                ].includes(url) ||
                url.includes(this.DASHBOARD_AZURETEST_PR_TO_DEV_URL) ||
                url.includes(this.DASHBOARD_AZURETEST_DEV_TO_MAIN_URL)
            );
        } catch (e) {
            console.error("Invalid URL:", url, e);
            return false;
        }
    };
    
    static isTestEnviromentUrl = (url) => {
        let urlObject = new URL(url);
        url = urlObject.protocol + "//" + urlObject.hostname;

        return (
            [this.DASHBOARD_TEST_URL, this.DASHBOARD_DEV_URL].includes(url) ||
            url.includes(this.DASHBOARD_AZURETEST_PR_TO_DEV_URL) ||
            url.includes(this.DASHBOARD_AZURETEST_DEV_TO_MAIN_URL)
        );
    };
}
